import React from 'react'
import {Button, Modal} from 'react-daisyui'

interface MultiInvoiceModalProps {
  isOpen: boolean
  invoiceCount: number
  onClose: () => void
  onConfirm: () => void
}

const MultiInvoiceModal: React.FC<MultiInvoiceModalProps> = ({
  isOpen,
  invoiceCount,
  onClose,
  onConfirm
}) => {
  const {Dialog} = Modal.useDialog()

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <h2 className="font-bold text-2xl mb-4 text-center">Just a heads up</h2>
      <p className="mb-6 text-center">
        There will be {invoiceCount} invoice pdfs generated for this stay. If
        you have any issues, please reach out to us at hello@placemakr.com
      </p>
      <Button
        color="secondary"
        className="btn-wide block mx-auto"
        onClick={onConfirm}
      >
        OK, got it!
      </Button>
    </Dialog>
  )
}

export default MultiInvoiceModal
